(function() {

    if(document.querySelector('.js-submenu')) {
        const submenuItem = document.querySelectorAll('.submenu__item');

        // Set initial image for each menu's first item on load
        window.addEventListener('load', () => {
            document.querySelectorAll('.header-menu__sub-img').forEach((imageTarget) => {
                const parentSub = imageTarget.closest('.header-menu__sub');
                if (!parentSub) return;
                const firstItem = parentSub.querySelector('.submenu .submenu__item:nth-child(2)');
                if (firstItem) {
                    const firstData = firstItem.getAttribute('data-image');
                    const firstURL = firstItem.getAttribute('data-url');
                    if (firstData) imageTarget.style.backgroundImage = "url(" + firstData + ")";
                    if (firstURL) {
                        const link = imageTarget.querySelector('.link');
                        if (link) link.setAttribute('href', firstURL);
                    }
                }
            });
        });

        submenuItem.forEach((item) => {
            item.addEventListener('mouseover', () => {
                let submenuItemData = item.getAttribute('data-image');
                let submenuItemURL = item.getAttribute('data-url');
                // Find the image panel within the same dropdown, not always the first on the page
                const parentSub = item.closest('.header-menu__sub');
                const imageTarget = (parentSub && parentSub.querySelector('.header-menu__sub-img'))
                    || document.querySelector('.header-menu__sub-img');
                if (!imageTarget) return;
                if (submenuItemData) imageTarget.style.backgroundImage = "url(" + submenuItemData + ")";
                if (submenuItemURL) {
                    const link = imageTarget.querySelector('.link');
                    if (link) link.setAttribute('href', submenuItemURL);
                }
            })
        })

        const submenuLevel1Item = document.querySelectorAll('.submenu-level-1__item');
        submenuLevel1Item.forEach((item) => {
            item.addEventListener('mouseover', (e) => {
                let submenuItemData = item.getAttribute('data-image');
                let submenuItemURL = item.getAttribute('data-url');
                if (!submenuItemData) return;
                e.stopPropagation();
                const parentSub = item.closest('.header-menu__sub');
                const imageTarget = (parentSub && parentSub.querySelector('.header-menu__sub-img'))
                    || document.querySelector('.header-menu__sub-img');
                if (!imageTarget) return;
                imageTarget.style.backgroundImage = "url(" + submenuItemData + ")";
                if (submenuItemURL) {
                    const link = imageTarget.querySelector('.link');
                    if (link) link.setAttribute('href', submenuItemURL);
                }
            })
        })
    }

    if(document.querySelector('.js-burger')) {
        const burger = document.querySelector('.js-burger');
        const headerNav = document.querySelector('.js-header-nav');
        const headerMenu = document.querySelector('.js-header-menu');
        const headerMenuSub = document.querySelectorAll('.js-header-menu-sub');
        const headerMenuItemButton = document.querySelectorAll('.js-header-menu-item-button');
        const headerSubMenuItemButton = document.querySelectorAll('.js-header-submenu-item-button');
        const headerSubMenuItemButtonLevel1 = document.querySelectorAll('.js-header-submenu-level-1-item-button');
        const headerMenuItemBack = document.querySelectorAll('.js-menu-item-back');
        const headerSubMenuItemBack = document.querySelectorAll('.js-submenu-item-back');

        burger.addEventListener('click', () => {
            if(burger.classList.contains('is-active')) {
                burger.classList.remove('is-active');
                headerNav.classList.remove('is-active');
                headerMenu.classList.remove('is-active');
                headerMenuItemButton.forEach((button) => {
                    button.classList.remove('is-active');
                    const headerSub = button.closest('.header-menu__item').querySelector('.js-header-menu-sub');
                    const subMenu = headerSub.querySelector('.js-submenu');
                    headerSub.classList.remove('is-active');
                    subMenu.classList.remove('is-active');
                })
                headerSubMenuItemButton.forEach((button) => {
                    button.classList.remove('is-active');
                    const headerSub = button.closest('.submenu__item').querySelector('.js-submenu-level-1');
                    headerSub.classList.remove('is-active');
                })
                headerSubMenuItemButtonLevel1.forEach((button) => {
                    button.classList.remove('is-active');
                    const headerSub = button.closest('.submenu-level-1__item').querySelector('.js-submenu-level-2');
                    headerSub.classList.remove('is-active');
                })
            } else {
                burger.classList.add('is-active');
                headerNav.classList.add('is-active');
                headerMenu.classList.add('is-active');
            }
        });

        headerMenuItemButton.forEach((button) => {
            button.addEventListener('click', () => {
                const headerSub = button.closest('.header-menu__item').querySelector('.js-header-menu-sub');
                const subMenu = headerSub.querySelector('.js-submenu');
                headerSub.classList.add('is-active');
                subMenu.classList.add('is-active');
            });
        });

        headerSubMenuItemButton.forEach((button) => {
            button.addEventListener('click', () => {
                const headerSub = button.closest('.submenu__item').querySelector('.js-submenu-level-1');
                headerSub.classList.add('is-active');
            });
        });

        headerSubMenuItemButtonLevel1.forEach((button) => {
            button.addEventListener('click', () => {
                const headerSub = button.closest('.submenu-level-1__item').querySelector('.js-submenu-level-2');
                headerSub.classList.add('is-active');
            });
        });

        headerMenuItemBack.forEach((button) => {
            button.addEventListener('click', () => {
                const headerSub = button.closest('ul');
                headerSub.classList.remove('is-active');
                headerMenuSub.forEach((subMenu) => {
                    subMenu.classList.remove('is-active');
                })
            });
        });

        headerSubMenuItemBack.forEach((button) => {
            button.addEventListener('click', () => {
                const headerSub = button.closest('ul');
                headerSub.classList.remove('is-active');
            });
        });
    }


    // Product view

    if(document.querySelectorAll('.js-view-product-info-container')) {
        const viewProductInfo = document.querySelectorAll('.js-view-product-info-container .product-table__element');
        const viewProductInfoClose = document.querySelectorAll('.js-view-product-info-close');
        const viewProductInfoContainers = document.querySelectorAll('.js-view-product-info-container');

        viewProductInfo.forEach((item) => {
            item.addEventListener('click', () => {
                let viewProductInfoContainer = item.closest('.js-view-product-info-container');

                if(item.classList.contains('is-active')) {
                    viewProductInfoContainer.classList.remove('is-active');
                    item.classList.remove('is-active');
                } else {
                    viewProductInfoContainers.forEach((item) => item.classList.remove('is-active'));
                    viewProductInfo.forEach((item) => item.classList.remove('is-active'));
                    viewProductInfoContainer.classList.add('is-active');
                    item.classList.add('is-active');
                }
            });
        })

        viewProductInfoClose.forEach((item) => {
            item.addEventListener('click', () => {
                let viewProductInfoContainer = item.closest('.js-view-product-info-container');
                viewProductInfoContainer.classList.remove('is-active');
            });
        })
    }

    if(document.querySelector(".js-accordion-item") != null) {
        const accordionItem = document.querySelectorAll(".js-accordion-item");
        accordionItem.forEach((item,index)=>{
            let header = item.querySelector(".js-accordion-button");
            header.addEventListener("click", function() {
                item.classList.toggle("active");
        
                let description = item.querySelector(".js-accordion-content");
                if(item.classList.contains("active")){
                    description.style.height=`${description.scrollHeight + 5}px`;
                }else{
                    description.style.height = "0px";
                }
            })
        })

        window.addEventListener('load', () => {
            accordionItem.forEach((item) => {
                let accordionItemContent = item.querySelector('.js-accordion-content');
                if(accordionItemContent.innerHTML == 0){
                    item.classList.remove('active');
                }
            }) 
        });
      
    }

    const scrollToStep2 = function() {
      const target = document.querySelector('.seal-type-wrapper--2');
      if (target) {
        const y = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }

    // security page
    if(document.querySelector('.js-securrity-type') != null) {
        const element = document.querySelector('.specs-attributes-wrapper')
        const securityType = document.querySelectorAll('.js-securrity-type');
        let extraColors = document.querySelectorAll('.pull-tight');
        const securityCustomType = document.querySelectorAll('.js-custom-seal-type');
        securityType.forEach((item)=>{
            item.addEventListener('click', () => {
                // if (element.classList.contains("hidden")) {
                //     document.querySelector('.placeholder').classList.add('hidden')
                //     element.classList.remove('hidden');
                // }
                securityType.forEach((item) => item.classList.remove('active'));
                item.classList.add('active');
                document.querySelector('.js-seal-type-shop a').classList.add('type');
              if(window.innerWidth < 769){
                setTimeout(function(){
                  scrollToStep2()
                }, 300)
              }
                // document.querySelector('magnet-element input').click()
                // if (item.getAttribute('data-item') == "bolt-seals") {
                //     document.querySelector('.length-wrapper').classList.add('hidden')
                // } else if (item.getAttribute('data-item') == "pull-tight-seals") {
                //     document.querySelector('.length-wrapper').classList.remove('hidden')
                //     extraColors.forEach((item)=>{
                //         item.classList.remove('hidden')
                //     });
                // } else {
                //     document.querySelector('.length-wrapper').classList.add('hidden')
                //     extraColors.forEach((item)=>{
                //         item.classList.add('hidden')
                //     });
                // }

            })
        })
    }

    document.addEventListener('DOMContentLoaded', function () {
      const section = document.querySelector('.section-seal-type');
      const ctaWrapper = document.querySelector('.cta-wrapper');
      const headerWrapper = document.querySelector('.header-sticky');
    
      if (!section || !ctaWrapper || !headerWrapper) return;

      function add_offset () {
        if(headerWrapper.classList.contains('header-hidden')) {
          ctaWrapper.classList.add('sticky-cta-hh');
        } else {
          ctaWrapper.classList.remove('sticky-cta-hh');
        }
      }

      if (headerWrapper) {
        const observer = new MutationObserver(function (mutationsList) {
          for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              add_offset();
            }
          }
        });
        observer.observe(headerWrapper, { attributes: true, attributeFilter: ['class'] });
      }
      
      function onScroll() {
        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const sectionHeight = rect.height;
        const sectionTop = rect.top;
        const section25 = sectionTop + sectionHeight * 0.35;
    
        if (section25 < windowHeight && sectionTop + sectionHeight > 0) {
          ctaWrapper.classList.add('sticky-cta-footer');
        } else {
          ctaWrapper.classList.remove('sticky-cta-footer');
        }
        add_offset();
      }
    
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      
    });
    
    if(document.querySelector('.js-custom-seal-type') != null) {
        const securityTypeCustom = document.querySelectorAll('.js-custom-seal-type');
        const securityType = document.querySelectorAll('.js-securrity-type');
        securityTypeCustom.forEach((item)=>{
            item.addEventListener('click', () => {
                securityTypeCustom.forEach((item) => item.classList.remove('active'));
                item.classList.add('active');
                document.querySelector('.js-seal-type-shop a').classList.add('seal');
            })
        })
    }

    if(window.matchMedia("(max-width: 1023px)").matches) {
        
        if(document.querySelector('a[data-login="js-login-button"]') != null) {
            const loginButton = document.querySelector('a[data-login="js-login-button"]');
            const loginButtonContainer = document.querySelector('.js-login-button-container');
            loginButton.addEventListener('click', (e) => {
                e.preventDefault();
                if(loginButton.classList.contains('is-active')) {
                    loginButton.classList.remove('is-active');
                    loginButtonContainer.classList.remove('is-active');
                } else {
                    loginButton.classList.add('is-active');
                    loginButtonContainer.classList.add('is-active');
                }
            })
        }
    }

    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = "_blank";
            links[i].rel = "noreferrer noopener";
        }
    }

    document.addEventListener("DOMContentLoaded", function () {
        const phoneInput = document.querySelector("input[name='contact[Phone Number]']");

        if (phoneInput) {
            phoneInput.addEventListener("input", function () {
                this.value = this.value.replace(/[^0-9+()-\s]/g, ""); // Allow only numbers, +, (), and spaces
            });

            phoneInput.addEventListener("blur", function () {
                const phonePattern = /^[+]?[0-9\s()-]{7,15}$/; // Basic phone number validation
                if (!phonePattern.test(this.value)) {
                    this.classList.add("error");
                } else {
                    this.classList.remove("error");
                }
            });
        }
    });

})();
